module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/setting/setting.component.css
// module id = ./src/app/ultilities/setting/setting.component.css
// module chunks = main